import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');

export function completeToast(successKey, partialSuccessKey, response) {
  if (response.SuccessRowCount === response.TotalRowCount) {
    window.App.views.alertCenter.toastConfirmation(i18n.getString(successKey, {
      success: response.SuccessRowCount,
      total: response.TotalRowCount,
    }));
  } else {
    window.App.views.alertCenter.toastWarning(i18n.getString(partialSuccessKey, {
      success: response.SuccessRowCount,
      total: response.TotalRowCount,
    }));
  }
  return response;
}

export function failedToast(failedKey, response) {
  window.App.views.alertCenter.toastError(i18n.getString(failedKey));
  return response;
}
